<template>
  <div class="infoDiv">
    <div class="h3title">基本信息</div>
    <div class="formbox">
      <el-form class="glo_formBox" label-width="120px">
        <el-form-item label="车次属性:">
          <el-input
            v-model="dialogFormDispatch.dispatchPropertyShow"
            disabled
            placeholder="请输入"
          ></el-input>
        </el-form-item>
        <el-form-item label="配载批次:">
          <el-input
            v-model="number"
            disabled
            placeholder="自动生成"
            clearable
          ></el-input>
        </el-form-item>
        <el-form-item label="预计发车日期:" required>
          <el-date-picker
            v-model="dialogFormDispatch.planDepartureTime"
            class="input"
            value-format="yyyy-MM-dd"
            type="date"
            placeholder="选择日期"
          ></el-date-picker>
        </el-form-item>
        <el-form-item label="送货计划:">
          <el-select
            filterable
            clearable
            v-model="dialogFormDispatch.startAddrType"
            placeholder="请选择"
          >
            <el-option
              v-for="(item, index) in startAddrTypeList"
              :key="index"
              :label="item.name"
              :value="item.val"
            ></el-option>
          </el-select>
        </el-form-item>
        <el-form-item
          label="始发网点:"
          :required="dialogFormDispatch.startAddrType == 1"
        >
          <el-select
            v-model="dialogFormDispatch.startDeptId"
            placeholder="请选择"
            clearable
          >
            <el-option
              v-for="item in storageList"
              :key="item.documentId"
              :label="item.name"
              :value="item.documentId"
            ></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="车辆类型:">
          <el-select
            filterable
            clearable
            v-model="dialogFormDispatch.carCategoryConfDictId"
            placeholder="请选择"
            @change="changecarCategoryConfDictId"
          >
            <el-option
              v-for="(item, index) in car_categoryList"
              :key="index"
              :label="item.key"
              :value="item.confDictId"
            ></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="是否牵引车:">
          <el-select
            filterable
            clearable
            v-model="dialogFormDispatch.isTractor"
            placeholder="请选择"
          >
            <el-option
              v-for="(item, index) in isTractorList"
              :key="index"
              :label="item.name"
              :value="item.val"
            ></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="车型:">
          <el-select
            filterable
            clearable
            v-model="dialogFormDispatch.carTypeConfDictId"
            placeholder="请选择"
          >
            <el-option
              v-for="(item, index) in car_type_list"
              :key="index"
              :label="item.key"
              :value="item.confDictId"
            ></el-option>
          </el-select>
        </el-form-item>
        <el-form-item required label="车牌号码:">
          <el-select
            filterable
            clearable
            allow-create
            remote
            v-model="dialogFormDispatch.carNumber"
            placeholder="请选择"
          >
            <el-option
              v-for="(item, index) in carNumberList1"
              :key="index"
              :label="item.carNumber"
              :value="item.carNumber"
            ></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="挂车号码:">
          <el-select
            v-model="dialogFormDispatch.trailerNumber"
            :remote-method="(e) => getcarNumberRmethod(e)"
            filterable
            clearable
            allow-create
            remote
            placeholder="请选择"
          >
            <el-option
              v-for="(item, index) in carNumberList2"
              :key="index"
              :label="item.carNumber"
              :value="item.carNumber"
            ></el-option>
          </el-select>
        </el-form-item>
        <el-form-item required label="司机一:">
          <el-select
            filterable
            clearable
            v-model="dialogFormDispatch.driverOneName"
            placeholder="请选择"
            allow-create
            remote
            :remote-method="
              (val) => runPageReport_down_list_driver('driverList1', val)
            "
            @focus="runPageReport_down_list_driver('driverList1')"
            @change="
              changeDrivers(
                $event,
                'driverOneId',
                'driverOneName',
                'driverList1',
                'driverOnePhone',
                'driverOneIdcard'
              )
            "
          >
            <el-option
              v-for="(item, index) in driverList1"
              :key="index"
              :label="item.name"
              :value="item.name"
            ></el-option>
          </el-select>
        </el-form-item>
        <el-form-item required label="司机一电话:">
          <el-input
            v-model="dialogFormDispatch.driverOnePhone"
            placeholder="请输入"
          ></el-input>
        </el-form-item>
        <el-form-item label="司机一身份证:">
          <el-input
            v-model="dialogFormDispatch.driverOneIdcard"
            placeholder="请输入"
          ></el-input>
        </el-form-item>
        <el-form-item label="司机二:">
          <el-select
            filterable
            clearable
            v-model="dialogFormDispatch.driverTwoName"
            placeholder="请选择"
            allow-create
            remote
            :remote-method="
              (val) => runPageReport_down_list_driver('driverList2', val)
            "
            @focus="runPageReport_down_list_driver('driverList2')"
            @change="
              changeDrivers(
                $event,
                'driverTwoId',
                'driverTwoName',
                'driverList2',
                'driverTwoPhone',
                'driverTwoIdcard'
              )
            "
          >
            <el-option
              v-for="(item, index) in driverList2"
              :key="index"
              :label="item.name"
              :value="item.name"
            ></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="司机二电话:">
          <el-input
            v-model="dialogFormDispatch.driverTwoPhone"
            placeholder="请输入"
          ></el-input>
        </el-form-item>
        <el-form-item label="司机二身份证:">
          <el-input
            v-model="dialogFormDispatch.driverTwoIdcard"
            placeholder="请输入"
          ></el-input>
        </el-form-item>
        <el-form-item label="押运员一:">
          <el-select
            v-model="dialogFormDispatch.supercargoOneName"
            placeholder="请选择"
            filterable
            clearable
            allow-create
            remote
            :remote-method="
              (val) => runPageReport_down_list_driver('driverList3', val)
            "
            @focus="runPageReport_down_list_driver('driverList3')"
            @change="
              changeDrivers(
                $event,
                'supercargoOneId',
                'supercargoOneName',
                'driverList3'
              )
            "
          >
            <el-option
              v-for="(item, index) in driverList3"
              :key="index"
              :label="item.name"
              :value="item.name"
            ></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="押运员二:">
          <el-select
            v-model="dialogFormDispatch.supercargoTwoName"
            placeholder="请选择"
            filterable
            clearable
            allow-create
            remote
            :remote-method="
              (val) => runPageReport_down_list_driver('driverList4', val)
            "
            @focus="runPageReport_down_list_driver('driverList4')"
            @change="
              changeDrivers(
                $event,
                'supercargoTwoId',
                'supercargoTwoName',
                'driverList4'
              )
            "
          >
            <el-option
              v-for="(item, index) in driverList4"
              :key="index"
              :label="item.name"
              :value="item.name"
            ></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="随车人员一:">
          <el-select
            v-model="dialogFormDispatch.carFollowPersonnelOneName"
            placeholder="请选择"
            clearable
            remote
            filterable
            :remote-method="
              (e) => {
                remoteMethod(e, 'employee', 'employeeList');
              }
            "
            @focus="focusMethod('employee', 'employeeList')"
            @clear="remoteMethod('', 'employee', 'employeeList')"
          >
            <el-option
              v-for="(item, index) in employeeList"
              :key="index"
              :label="item.name"
              :value="item.name"
            />
          </el-select>
        </el-form-item>
        <el-form-item label="随车人员二:">
          <el-select
            v-model="dialogFormDispatch.carFollowPersonnelTwoName"
            placeholder="请选择"
            clearable
            remote
            filterable
            :remote-method="
              (e) => {
                remoteMethod(e, 'employee', 'employeeList2');
              }
            "
            @focus="focusMethod('employee', 'employeeList2')"
            @clear="remoteMethod('', 'employee', 'employeeList2')"
          >
            <el-option
              v-for="(item, index) in employeeList2"
              :key="index"
              :label="item.name"
              :value="item.name"
            />
          </el-select>
        </el-form-item>
        <el-form-item label="发车合同号:">
          <el-input
            v-model="dialogFormDispatch.dispatchContractNumber"
            placeholder="请输入"
          ></el-input>
        </el-form-item>
        <el-form-item label="应付合计:">
          <el-input
            v-model="dialogFormDispatch.totalAmount"
            placeholder="请输入"
            clearable
            type="number"
          ></el-input>
        </el-form-item>
        <el-form-item class="textArea" style="width: 100%" label="备注:">
          <el-input
            type="textarea"
            v-model="dialogFormDispatch.remarks"
          ></el-input>
        </el-form-item>
      </el-form>
    </div>
    <div class="h3title">配载明细</div>
    <div class="glo_btnList" ref="btnList">
      <div class="glo_btnList_left">
        <el-button class="glo_btnItems" @click="clickAdd">单票添加</el-button>
        <el-button class="glo_btnItems" @click="clickRetrieve"
          >取出明细</el-button
        >
        <el-button class="glo_btnItems" @click="clickDel">移除</el-button>
      </div>
    </div>
    <!-- 表格 -->
    <div class="glo_Table">
      <el-table
        header-align="center"
        ref="mytable"
        :data="tableData1"
        @selection-change="handleSelectionChange1"
      >
        <el-table-column
          fixed="left"
          align="center"
          label="序号"
          type="index"
          width="60"
        ></el-table-column>
        <el-table-column
          fixed="left"
          align="center"
          type="selection"
          width="60"
        ></el-table-column>
        <template v-for="(item, index) in myTableHeard1">
          <!-- 某个字段需要单独操作  例如点击可以跳转 -->
          <el-table-column
            :key="index"
            :label="item.name"
            :prop="item.field"
            align="center"
            sortable
            :show-overflow-tooltip="true"
            :min-width="item.width"
            :data-isTotal="item.isTotal"
            v-if="item && item.isShow"
          ></el-table-column>
        </template>
      </el-table>
    </div>

    <!-- 单票添加 -->
    <myDialog
      :diaWidth="diaWidth2"
      :dialogTitle="dialogTitle2"
      :isShowDialog="isShowDialog2"
      @handleCloseDia="handleCloseDia2"
      @diaCancelBtn="handleCloseDia2"
      @diaConfirmBtn="diaConfirmBtn2"
    >
      <div class="formbox" v-if="isShowDialog2">
        <el-form class="glo_formBox" label-width="110px">
          <el-form-item label="运单号:" style="width:100%;">
            <!-- <el-input v-model="dialogForm2.waybillNumber" placeholder="请输入"></el-input> -->
            <el-select
              v-model="dialogForm2.waybillNumber"
              placeholder="请选择"
              clearable
              remote
              filterable
              :remote-method="
                (e) => {
                  remoteMethod_runPageReport(e);
                }
              "
              @focus="focusMetho_runPageReport()"
              @clear="remoteMethod_runPageReport('')"
            >
              <el-option
                v-for="(item, index) in waybillNumberList"
                :key="index"
                :label="item.waybillNumber"
                :value="item.waybillNumber"
              />
            </el-select>
          </el-form-item>
        </el-form>
      </div>
    </myDialog>

    <!-- 取出明细 -->
    <myDialog
      :diaWidth="diaWidth4"
      :dialogTitle="dialogTitle4"
      :isShowDialog="isShowDialog4"
      @handleCloseDia="handleCloseDia4"
      @diaCancelBtn="handleCloseDia4"
      @diaConfirmBtn="diaConfirmBtn4"
    >
      <div class="glo_dialogForm" v-if="isShowDialog4">
        <!-- 查询条件 -->
        <div class="btnsform">
          <queryCondition
            ref="queryForm"
            :More="isHaseMore"
            :formConfig="queryCondditionDatas"
          ></queryCondition>
          <el-button class="glo_btnItems glo_bgcMainColor" @click="clickQuery4"
            >查询</el-button
          >
        </div>
        <!-- 表格 -->
        <div class="glo_Table">
          <el-table
            header-align="center"
            ref="mytable4"
            @row-click="rowclick4"
            :data="tableData4"
            border
            stripe
            :highlight-current-row="true"
            @selection-change="handleSelectionChange4"
          >
            <el-table-column
              fixed="left"
              align="center"
              label="序号"
              type="index"
              width="60"
            ></el-table-column>
            <el-table-column
              fixed="left"
              align="center"
              type="selection"
              width="60"
            ></el-table-column>
            <template v-for="(item, index) in myTableHeard4">
              <el-table-column
                :key="index"
                :label="item.name"
                :prop="item.field"
                align="center"
                sortable
                :show-overflow-tooltip="true"
                :min-width="item.width"
                :data-isTotal="item.isTotal"
                v-if="item && item.isShow"
              ></el-table-column>
            </template>
          </el-table>
        </div>
      </div>
    </myDialog>
  </div>
</template>
<script>
import myDialog from "@/components/Dialog.vue";
import queryCondition from "@/components/queryCondition.vue";
export default {
  inject: ["reload"],
  props: {
    dispatchId: {
      typeof: String,
      default: "",
    },
  },
  components: {
    myDialog,
    queryCondition,
  },
  data() {
    return {
      initIds: [],
      tableData1: [],
      tableData1_1: [],
      //配载明细
      myTableHeard1: [
        {
          name: "运单号",
          field: "waybillNumber",
          width: "120",
          sort: 1,
          isShow: true, //是否展示
          isTotal: false, //是否开启合计
          isSort: true, //表格设置里面是否可以排序
        },
        {
          name: "应付分摊",
          field: "amount",
          width: "180",
          sort: 1,
          isShow: true, //是否展示
          isTotal: false, //是否开启合计
          isSort: true, //表格设置里面是否可以排序
        },
        {
          name: "货物名称",
          field: "goodsName",
          width: "180",
          sort: 1,
          isShow: true, //是否展示
          isTotal: false, //是否开启合计
          isSort: true, //表格设置里面是否可以排序
        },
        {
          name: "计费取值",
          field: "totalBillingWeight",
          width: "180",
          sort: 1,
          isShow: true, //是否展示
          isTotal: false, //是否开启合计
          isSort: true, //表格设置里面是否可以排序
        },
        {
          name: "件数",
          field: "packageCout",
          width: "180",
          sort: 1,
          isShow: true, //是否展示
          isTotal: false, //是否开启合计
          isSort: true, //表格设置里面是否可以排序
        },
        {
          name: "毛重",
          field: "grossWeight",
          width: "180",
          sort: 1,
          isShow: true, //是否展示
          isTotal: false, //是否开启合计
          isSort: true, //表格设置里面是否可以排序
        },
        {
          name: "净重",
          field: "netWeight",
          width: "180",
          sort: 1,
          isShow: true, //是否展示
          isTotal: false, //是否开启合计
          isSort: true, //表格设置里面是否可以排序
        },
        {
          name: "体积",
          field: "volume",
          width: "180",
          sort: 1,
          isShow: true, //是否展示
          isTotal: false, //是否开启合计
          isSort: true, //表格设置里面是否可以排序
        },
        {
          name: "客户名称",
          field: "customerName",
          width: "180",
          sort: 1,
          isShow: true, //是否展示
          isTotal: false, //是否开启合计
          isSort: true, //表格设置里面是否可以排序
        },
        {
          name: "发货人",
          field: "contacts",
          width: "180",
          sort: 1,
          isShow: true, //是否展示
          isTotal: false, //是否开启合计
          isSort: true, //表格设置里面是否可以排序
        },
        {
          name: "联系电话",
          field: "phone",
          width: "180",
          sort: 1,
          isShow: true, //是否展示
          isTotal: false, //是否开启合计
          isSort: true, //表格设置里面是否可以排序
        },
        {
          name: "提货时间",
          field: "takeTime",
          width: "180",
          sort: 1,
          isShow: true, //是否展示
          isTotal: false, //是否开启合计
          isSort: true, //表格设置里面是否可以排序
        },
        {
          name: "交货日期",
          field: "deliveryTime",
          width: "180",
          sort: 1,
          isShow: true, //是否展示
          isTotal: false, //是否开启合计
          isSort: true, //表格设置里面是否可以排序
        },
        {
          name: "到货区域",
          field: "arrivalArea",
          width: "180",
          sort: 1,
          isShow: true, //是否展示
          isTotal: false, //是否开启合计
          isSort: true, //表格设置里面是否可以排序
        },
        {
          name: "装货地址",
          field: "takeAddr",
          width: "180",
          sort: 1,
          isShow: true, //是否展示
          isTotal: false, //是否开启合计
          isSort: true, //表格设置里面是否可以排序
        },
        {
          name: "收货地址",
          field: "endAddr",
          width: "180",
          sort: 1,
          isShow: true, //是否展示
          isTotal: false, //是否开启合计
          isSort: true, //表格设置里面是否可以排序
        },
        {
          name: "创建时间",
          field: "createTime",
          width: "180",
          sort: 1,
          isShow: true, //是否展示
          isTotal: false, //是否开启合计
          isSort: true, //表格设置里面是否可以排序
        },
      ],

      dialogFormDispatch: {
        dispatchPropertyShow: "",
        planDepartureTime: this.$TOOLS.getCurrentDate(),
        startAddrType: 1,
        startDeptId: "",
        carCategoryConfDictId: "",
        isTractor: 0,
        carTypeConfDictId: "",
        carNumber: "",
        trailerNumber: "",
        driverOneId: "",
        driverOnePhone: "",
        driverOneIdcard: "",
        driverTwoId: "",
        driverTwoPhone: "",
        driverTwoIdcard: "",
        supercargoOneId: "",
        supercargoTwoId: "",
        carFollowPersonnelOneName: "",
        carFollowPersonnelTwoName: "",
        dispatchContractNumber: "",
        totalAmount: "",
        remarks: "",
      },
      driverList: [], //司机列表
      driverList1: [], //司机列表
      driverList2: [], //司机列表
      driverList3: [], //司机列表
      driverList4: [], //司机列表
      car_categoryList: [], //车辆分类
      carNumberList1: [], //车牌号码
      carNumberList2: [], //挂车号码
      car_type_list: [], //车型
      storageList: [],
      isTractorList: [
        //是否牵引车
        { val: 0, name: "否" },
        { val: 1, name: "是" },
      ],
      employeeList: [],
      employeeList2: [],
      number: "",
      startAddrTypeList: [
        { val: 1, name: "仓配送货" },
        { val: 2, name: "提货直送" },
      ],
      selectTableData1: [],

      isShowDialog2: false,
      dialogTitle2: "单票添加运单",
      diaWidth2: "520px",
      dialogForm2: {
        waybillNumber: "",
      },

      isShowDialog4: false,
      dialogTitle4: "取出明细",
      diaWidth4: "90%",
      tableData4: [],
      myTableHeard4: [],
      selectTableData4: [], //收发地址 表格选择
      pageGroupName: "DispatchCar_DeliveryScheduling", //  页面标识
      reportFiledsNumber: "admin_dispatch_send_list", // 动态 条件、表头
      queryCondditionDatas: [],
      originalTabelHeadeTitle: [],
      tabelHeadeTitle: [],
      isHaseMore: true, //false == 更多条件  true ==收起条件
      waybillNumberList: [],
    };
  },
  watch: {
    dispatchId(a, b) {
      if (a) {
        this.getDispatchDetailApi();
      }
    },
  },
  created() {},
  mounted() {
    this.getConfDictValDownLists("car_type");
    this.getConfDictValDownLists("car_category");
    this.getObjectUserDownList("driver");
    this.getObjectUserDownList("storage"); //网点
    this.getcarNumberRmethod("");
    this.initTable();
    this.$nextTick(() => {
      this.getDispatchDetailApi();
    });
  },
  // activated() {
  //   this.$nextTick(() => {
  //     this.getDispatchDetailApi();
  //   });
  // },
  destroyed() {},
  methods: {
    getData() {
      let conditionReqs = [];
      let F_config = this.$refs.queryForm.F_config;
      F_config.forEach((element) => {
        let {
          textBoxType,
          conditonKey,
          dropdownSubmitField,
          conditonVal,
          timeType,
          timeChilds,
          startTime_a,
          endTime_a,
        } = element;
        switch (textBoxType) {
          case "input":
            conditionReqs.push({
              conditonKey,
              conditonVal,
            });
            break;
          case "select":
            conditionReqs.push({
              conditonKey: dropdownSubmitField || conditonKey,
              conditonVal,
            });
            break;
          case "datetime":
            let curs = timeChilds[timeType];
            curs &&
              curs.children.forEach((element, index) => {
                console.log(element);
                conditionReqs.push({
                  conditonKey: element.conditonKey,
                  conditonVal:
                    index == 1
                      ? `${endTime_a} 23:59:59`
                      : `${startTime_a} 00:00:00`,
                });
              });
            break;
          default:
            break;
        }
      });
      let params = {
        conditionReqs,
        pageStart: 1,
        pageTotal: 100,
        number: this.reportFiledsNumber,
      };
      this.$API.runPageReport(params).then((res) => {
        if (res.data.status === "success") {
          let datas = res.data.result.datas || {};
          this.tableData4 = datas.data || [];
        } else {
          this.$message.error(`${res.data.message}---综合查询列表`);
        }
      });
    },
    async initTable() {
      //获取 所有页面 number
      await this.$API
        .getQueryList({
          number: "",
          reportName: "",
        })
        .then((res) => {});
      //获取当前页面已设置表头
      await this.$API
        .getGroupFindFieldSort({
          groupName: this.pageGroupName, //当前页面表格的标记(自定义字符串)
        })
        .then((res) => {
          let arr = res.data.result || [];
          if (arr.length > 0) {
            if (arr[0].sortObject) {
              this.tabelHeadeTitle = JSON.parse(arr[0].sortObject);
            }
          }
        });
      //表格 表头默认
      await this.$API
        .getReportFileds({
          number: this.reportFiledsNumber,
        })
        .then((res) => {
          let datas = res.data.result || [];
          let lists = [];
          datas.forEach((element) => {
            lists.push({
              name: element.fieldNameShow,
              field: element.fieldAlias,
              width: element.wide,
              isTotal: element.isSum,
              sort: element.sort,
              isShow: element.isshow == 0 ? false : true,
              isSort: true,
            });
          });
          this.originalTabelHeadeTitle = lists;
          if (!this.tabelHeadeTitle.length) {
            this.tabelHeadeTitle = this.originalTabelHeadeTitle;
          }
        });
      this.myTableHeard4 = this.tabelHeadeTitle;

      let arrsConddition = [];
      // 获取查询条件 list
      await this.$API
        .getReportConditions({
          number: this.reportFiledsNumber,
        })
        .then((res) => {
          let datas = res.data.result || [];
          if (datas && datas.length > 0) {
            datas.map((n) => (n.conditonVal = n.conditonVal || ""));
            let arrs = datas.filter((n) => {
              return n.textBoxType === "datetime";
            });
            let timeobjs = {};
            arrs.forEach((item) => {
              let { sort, conditonKeyShow } = item;
              let name = conditonKeyShow.includes("起始")
                ? conditonKeyShow.split("起始").join("")
                : conditonKeyShow.split("结束").join("");
              if (!timeobjs[sort]) {
                timeobjs[sort] = {
                  sort,
                  name,
                  children: [],
                };
              }
              timeobjs[sort].children.push(item);
            });
            let gdates = [];
            let dates = Object.values(timeobjs);
            if (dates.length) {
              console.log(dates);
              gdates = [
                {
                  textBoxType: "datetime",
                  startTime_a: this.$TOOLS.getFlexDate(this.$COMMON.timeNum),
                  endTime_a: this.$TOOLS.getCurrentDate(),
                  timeType: "0",
                  timeTypes: dates.map((n, i) => {
                    return { value: String(i), label: n.name };
                  }),
                  timeChilds: dates.map((n, i) => {
                    return { sort: n.sort, name: n.name, children: n.children };
                  }),
                  isShow: 1,
                },
              ];
            }
            arrsConddition = [
              ...gdates,
              ...datas.filter((n) => {
                return n.textBoxType !== "datetime";
              }),
            ];
          }
        });
      // 获取 每个查询条件 的下拉数据
      arrsConddition.forEach(async (element, index) => {
        let { textBoxType } = element;
        if (textBoxType == "select") {
          element.selectOptions = [];
        }
      });
      this.queryCondditionDatas = arrsConddition;
    },
    clickAdd() {
      this.isShowDialog2 = true;
    },
    handleCloseDia2() {
      this.isShowDialog2 = false;
      this.dialogForm2 = {
        waybillNumber: "",
      };
      this.waybillNumberList = [];
    },
    //  弹窗确认保存事件
    diaConfirmBtn2() {
      let { waybillNumber } = this.dialogForm2;
      if (!waybillNumber) {
        this.$message.warning("请输入运单号");
        return false;
      }
      let params = {
        conditionReqs: [
          {
            conditonKey: "waybillNumber",
            conditonVal: waybillNumber,
          },
        ],
        pageStart: 1,
        pageTotal: 100,
        number: this.reportFiledsNumber,
      };
      this.$API.runPageReport(params).then((res) => {
        if (res.data.status === "success") {
          let datas = res.data.result.datas.data || [];
          if (datas.length) {
            let cursnum = datas[0].waybillNumber;
            if (
              this.tableData1
                .map((n) => {
                  return n.waybillNumber;
                })
                .includes(cursnum)
            ) {
              this.$message.error(`运单 ${cursnum} 添加重复，请输入新的运单号`);
              return false;
            }
            this.tableData1.push(datas[0]);
            this.isShowDialog2 = false;
          } else {
            this.$message.error(`没有查询到运单 ${cursnum} `);
          }
        } else {
          this.$message.error(`${res.data.message}---综合查询列表`);
        }
      });
      // this.$API
      //   .waybillzhiSong({
      //     remarks,
      //   })
      //   .then((res) => {
      //     this.$message.success(res.data.message || "操作成功");
      //     this.isShowDialog2 = false;
      //     this.getData();
      //   });
    },
    focusMetho_runPageReport(key, keys) {
      if (this.waybillNumberList.length == 0) {
        this.remoteMethod_runPageReport("");
      }
    },
    remoteMethod_runPageReport(name) {
      let params = {
        conditionReqs: [
          {
            conditonKey: "waybillNumber",
            conditonVal: name,
          },
        ],
        pageStart: 1,
        pageTotal: 20,
        number: this.reportFiledsNumber,
      };
      this.$API.runPageReport(params).then((res) => {
        if (res.data.status === "success") {
          this.waybillNumberList = res.data.result.datas.data || [];
        } else {
          this.$message.error(`${res.data.message}---综合查询列表`);
        }
      });
    },

    async clickRetrieve() {
      this.isShowDialog4 = true;
      setTimeout(() => {
        this.clickQuery4();
      }, 0);
    },

    // 外发——————————
    arrayFilter(arr, key) {
      return arr.filter((item, index, self) => {
        // 利用findIndex方法找到第一个与当前元素id相等的元素索引
        const i = self.findIndex((t) => t[key] === item[key]);
        // 如果当前索引等于当前元素在self中的最初出现位置索引，则表示元素符合要求，不是重复元素，保留
        return i === index;
      });
    },
    //取出明细
    handleCloseDia4() {
      this.isShowDialog4 = false;
    },
    //取出明细  弹窗确认保存事件
    diaConfirmBtn4() {
      // 添加费项
      if (!this.selectTableData4.length) {
        this.$message.error(`请选择操作数据`);
        return false;
      }
      this.tableData1 = this.arrayFilter(
        [...this.selectTableData4, ...this.tableData1],
        "waybillNumber"
      );
      this.isShowDialog4 = false;
    },
    //取出明细 点击选中当前行
    rowclick4(row, event, column) {
      this.$refs.mytable4.toggleRowSelection(row);
    },
    //取出明细 表格选择事件
    handleSelectionChange4(e) {
      this.selectTableData4 = e;
    },
    clickQuery4() {
      this.getData();
    },

    handleSelectionChange1(e) {
      this.selectTableData1 = e;
    },
    clickDel() {
      if (this.tableData1.length <= 1) {
        this.$message.warning("配载明细至少留一条");
        return false;
      }
      if (this.selectTableData1.length < 1) {
        this.$message.warning("请选择需要操作的数据");
        return false;
      }
      let ids = [];
      this.selectTableData1.forEach((item) => {
        ids.push(item.waybillDispatchId);
      });
      let keyset = "waybillDispatchId";
      let deleteIndex = [];
      this.tableData1.filter((item, index) => {
        if (
          this.selectTableData1
            .map((n) => {
              return n[keyset];
            })
            .includes(item[keyset])
        ) {
          deleteIndex.push(index);
        }
      });
      if (deleteIndex.length > 0) {
        for (let i = deleteIndex.length - 1; i >= 0; i--) {
          this.tableData1.splice(deleteIndex[i], 1);
        }
      }
    },
    runPageReport_down_list_driver(key, e) {
      this.$API
        .runPageReport({
          conditionReqs: [
            {
              conditonKey: "name",
              conditonVal: e,
            },
          ],
          number: "down_list_driver",
          pageStart: 1,
          pageTotal: 200,
        })
        .then((res) => {
          this[key] = res.data.result.datas.data || [];
        });
    },
    // 选择司机/押运
    changeDrivers(e, id, name, listkey, phone, card) {
      this.dialogFormDispatch[id] = "";
      this.dialogFormDispatch[name] = "";
      this.dialogFormDispatch[phone] = "";
      this.dialogFormDispatch[card] = "";
      if (e) {
        this.dialogFormDispatch[name] = e;
        this[listkey].forEach((item) => {
          if (item.name == e) {
            this.dialogFormDispatch[id] = item.id || "";
            if (phone) {
              this.dialogFormDispatch[phone] = item.phone || "";
            }
            if (card) {
              this.dialogFormDispatch[card] = item.idCard || "";
            }
          }
        });
      }
    },
    // 提交
    async submit(saveType) {
      let curs = this.car_type_list.filter(
        (item) => item.confDictId == this.dialogFormDispatch.carTypeConfDictId
      );
      this.dialogFormDispatch.carType = (curs.length && curs[0].key) || "";
      this.dialogFormDispatch.dispatchId = this.dispatchId;
      this.dialogFormDispatch.saveType = saveType;
      let orderIds = [];
      this.tableData1.forEach((element, index) => {
        let operationType = "ADD";
        if (this.initIds.includes(element.waybillDispatchId)) {
          operationType = "UPDATE";
        }
        orderIds.push({
          waybillDispatchId: element.waybillDispatchId,
          sort: index,
          operationType,
        });
      });
      let arrsgg = [];
      this.tableData1_1.forEach((element, index) => {
        if (
          !orderIds.find((n) => {
            return n.waybillDispatchId == element.waybillDispatchId;
          })
        ) {
          arrsgg.push({
            waybillDispatchId: element.waybillDispatchId,
            sort: orderIds.length + index,
            operationType: "DEL",
          });
        }
      });
      this.dialogFormDispatch.orderIds = [...orderIds, ...arrsgg];

      await this.$API
        .updateSendDispatch(this.dialogFormDispatch)
        .then((res) => {
          if (res.data.status === "success") {
            this.$message.success(res.data.message || "操作成功");
            this.$TOOLS.closePage();
            this.$router.push({
              path: "/DispatchCar/VehicleStowage",
              query: {
                isreload: "isreload",
              },
            });
          } else {
            this.$message.error(`${res.data.message}---综合查询列表`);
          }
        });
    },

    getDispatchDetailApi() {
      this.$API
        .getDispatchDetail({ dispatchId: this.dispatchId })
        .then((res) => {
          let datas = res.data.result[0] || {};
          this.number = datas.number;
          this.dialogFormDispatch = {
            totalAmount: datas.totalAmount || "",
            startAddrType: datas.startAddrType || 1,
            dispatchPropertyShow: datas.dispatchPropertyShow || "",
            planDepartureTime: datas.planDepartureTime || "",
            startDeptId: datas.startDeptId || "",
            carCategory: datas.carCategory || "",
            carCategoryConfDictId: datas.carCategoryConfDictId || "",
            isTractor: datas.isTractor || 0,
            carType: datas.carType || "",
            carTypeConfDictId: datas.carTypeConfDictId || "",
            carNumber: datas.carNumber || "",
            trailerNumber: datas.trailerNumber || "",
            driverOneId: datas.driverOneId || "",
            driverOneIdcard: datas.driverOneIdcard || "",
            driverOneName: datas.driverOneName || "",
            driverOnePhone: datas.driverOnePhone || "",
            driverTwoId: datas.driverTwoId || "",
            driverTwoIdcard: datas.driverTwoIdcard || "",
            driverTwoName: datas.driverTwoName || "",
            driverTwoPhone: datas.driverTwoPhone || "",
            supercargoOneId: datas.supercargoOneId || "",
            supercargoOneName: datas.supercargoOneName || "",
            supercargoTwoId: datas.supercargoTwoId || "",
            supercargoTwoName: datas.supercargoTwoName || "",
            carFollowPersonnelOneId: datas.carFollowPersonnelOneId || "",
            carFollowPersonnelOneName: datas.carFollowPersonnelOneName || "",
            carFollowPersonnelTwoId: datas.carFollowPersonnelTwoId || "",
            carFollowPersonnelTwoName: datas.carFollowPersonnelTwoName || "",
            dispatchContractNumber: datas.dispatchContractNumber || "",
            remarks: datas.remarks || "",
          };
          this.tableData1 = datas.orderIds || [];
          this.tableData1_1 = JSON.parse(JSON.stringify(datas.orderIds || []));
          this.initIds = this.tableData1.map((n) => {
            return n.waybillDispatchId;
          });
          this.changecarCategoryConfDictId(
            this.dialogFormDispatch.carCategoryConfDictId
          );
        });
    },
    //员工、部门、外发网点
    focusMethod(key, keys) {
      if (this[keys].length == 0) {
        this.remoteMethod("", key, keys);
      }
    },
    // 员工、部门、外发网点
    remoteMethod(name, key, keys) {
      // employee 员工
      // dept 部门
      // storage 外发网点
      return this.$API
        .wtl_getObjectUserDownList({
          name,
          key,
          pageStart: 1,
          pageTotal: 20,
        })
        .then((res) => {
          let arrs = res.data.result.data || [];
          this[keys] = arrs;
        });
    },
    // 根据字典类型获取字典值下拉列表
    getConfDictValDownLists(dictType) {
      this.$COMAPI.getConfDictValDownList(dictType).then((res) => {
        //车辆分类
        if (dictType == "car_category") {
          this.car_categoryList = res || [];
        }
        if (dictType == "car_type") {
          // 车型
          this.car_type_list = res || [];
        }
      });
    },
    // 获取车辆下拉列表(拿车牌号码)
    changecarCategoryConfDictId(e) {
      if (e) {
        let curs = this.car_categoryList.filter((item) => item.confDictId == e);
        this.dialogFormDispatch.carCategory =
          (curs.length && curs[0].key) || "";
        this.$API
          .CarDownList({
            pageStart: 1,
            pageTotal: 200,
            carNumber: "",
            carCategoryConfDictId: e, //车辆分类id
          })
          .then((res) => {
            this.carNumberList1 = res.data.result.data || [];
          });
      }
    },
    // 获取车辆下拉列表(拿挂车号码)
    getcarNumberRmethod(e) {
      this.$API
        .CarArchiveList({
          pageStart: 1,
          pageTotal: 200,
          carNumber: e || "",
        })
        .then((res) => {
          this.carNumberList2 = res.data.result.data || [];
        });
    },
    // 根据对象类型获取对象的下拉列表
    getObjectUserDownList(key) {
      this.$COMAPI.getObjectUserDownList(key).then((res) => {
        if (key == "driver") {
          this.driverList = res || [];
        }
        if (key == "storage") {
          //获取网点列表
          this.storageList = res || [];
        }
      });
    },
  },
};
</script>
<style scoped lang="less">
// 查询条件边框线
@borderColor: #cccccc;
.infoDiv {
  margin-bottom: 20px;
  .h3title {
    background-color: #f2f2f2;
    padding: 10px;
    border-bottom: 1px solid @borderColor;
    font-weight: bold;
    margin-bottom: 20px;
  }
}
.textArea {
  height: auto !important;
}
.btnsform {
  display: flex;
  align-items: flex-end;
  justify-content: space-between;
  margin-bottom: 10px;
}
</style>
